export default "__VITE_ASSET__CpIsI0JL__"